import React from "react";
import Registration from "../components/UI/registration-form/Registration";

function RegistrationPage(){
    return (
        <div className="App">
            <Registration/>
        </div>
    )
}

export default RegistrationPage;